import { setContext, setCustom, setLocation, setView, } from './context-actions.js';
import { contextReducer as commerceContext } from './context-slice.js';
/**
 * Loads the commerce context reducer and returns the available context action creators.
 *
 * @param engine - The commerce engine.
 * @returns An object holding the context action creators.
 *
 * @group Actions
 * @category Context
 */
export function loadContextActions(engine) {
    engine.addReducers({ commerceContext });
    return {
        setContext,
        setView,
        setLocation,
        setCustom,
    };
}
